import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TravelOverviewPage } from "../../components/travel-board/overview-page";

/** `/logistics/arrival-departure` — the Overview (M9b §1). `date` = the board day (games' zone; absent = today). Lenient. */
export const Route = createFileRoute("/_app/logistics/arrival-departure/")({
	validateSearch: z.object({ date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional().catch(undefined) }),
	component: OverviewRoute,
});

function OverviewRoute() {
	const { session } = Route.useRouteContext();
	return <TravelOverviewPage session={session} search={Route.useSearch()} navigate={Route.useNavigate()} />;
}
